import { render, staticRenderFns } from "./AuthSessionListener.vue?vue&type=template&id=0aa196cc&"
import script from "./AuthSessionListener.vue?vue&type=script&lang=js&"
export * from "./AuthSessionListener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports